import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "components/Common/PageHeader";
import TableFilterDynamique, { FilterField } from "components/Common/TableFilter/TableFilterDynamique";
import AuditLogsTable from "../tables/AuditLogsTable";
import useAuditLogs from "../hooks/useAuditLogs";
import { all_routes } from "router/all_routes";

const AuditLogs = () => {
  const { t } = useTranslation();
  const {
    logs,
    infoPagination,   // { page, limit, total }
    loading,
    error,
    fetchAuditLogs,
  } = useAuditLogs();

  const breadcrumbItems = [
    { label: "dashboard", path: all_routes.dashboard },
    { label: "audit_logs", active: true },
  ];

  const [filters, setFilters] = useState<{ [key: string]: string | number | null }>({});

  // Initial fetch
  useEffect(() => {
    fetchAuditLogs({ page: 1 , limit: 10 });
  }, [fetchAuditLogs]);

  // Define filterable fields
  const filterFields: FilterField[] = [
    {
      key: "action",
      label: t("action"),
      type: "select",
      options: [
        { label: t("create"), value: "create" },
        { label: t("update"), value: "update" },
        { label: t("delete"), value: "delete" },
      ],
    },
    // Add more filters when needed:
    // { key: "entity", label: t("entity"), type: "text" },
    // { key: "performedByEmail", label: t("user_email"), type: "text" },
  ];

  const handleFilter = (newFilters: { [key: string]: string | number | null }) => {
    setFilters(newFilters);
    fetchAuditLogs({ ...newFilters, page: 1 });
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader title={t("audit_logs")} breadcrumbItems={breadcrumbItems} />

        {/* Filters */}
        <div className="d-flex mb-3 justify-content-end gap-2">
          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={(newFilters) => handleFilter(newFilters)}
            onReset={() => {
              setFilters({});
              fetchAuditLogs({ page: 1 });
            }}
          />
        </div>

        {/* Table */}
        <AuditLogsTable
          dataSource={logs}
          loading={loading}
          pagination={true}
          dataPaginate={{
            current: infoPagination.page,
            pageSize: infoPagination.limit,
            total: infoPagination.total,
          }}
          onChange={(pg) => {
            fetchAuditLogs({
              ...filters,
              page: pg.current!,
              limit: pg.pageSize!,
            });
          }}
        />
      </div>
    </div>
  );
};

export default AuditLogs;
